import { useSelector } from 'react-redux';

/**
 * Returns true if the current user has the given permission.
 *
 * @param {string} moduleKey  - e.g. 'user', 'role', 'project'  (MODULE_KEYS constant)
 * @param {string} action     - 'view' | 'add' | 'update' | 'delete'  (ACTIONS constant)
 */
export function usePermission(moduleKey, action) {
  const { isSuperAdmin, permissions } = useSelector((state) => state.permissions);

  // Super-admin can do everything
  if (isSuperAdmin) return true;

  if (!moduleKey || !action) return false;
  if (!Array.isArray(permissions) || permissions.length === 0) return false;

  const key = moduleKey.toLowerCase();
  const match = permissions.find(
    (p) => String(p.moduleName || '').toLowerCase() === key
  );

  if (!match) return false;
  return Boolean(match.access?.[action.toLowerCase()]);
}

/**
 * Returns the full permissions object for a given module, or null if not found.
 * Useful for checking multiple actions in one call.
 *
 * @param {string} moduleKey
 * @returns {{ view, add, update, delete } | null}
 */
export function useModuleAccess(moduleKey) {
  const { isSuperAdmin, permissions } = useSelector((state) => state.permissions);

  if (isSuperAdmin) return { view: true, add: true, update: true, delete: true };
  if (!moduleKey || !Array.isArray(permissions)) return null;

  const key = moduleKey.toLowerCase();
  const match = permissions.find(
    (p) => String(p.moduleName || '').toLowerCase() === key
  );
  return match?.access ?? null;
}